webpackJsonp([230474096266302],{

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Anatomy = __webpack_require__(10);
	
	var _Anatomy2 = _interopRequireDefault(_Anatomy);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Anatomy2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      '/config/connect.js'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This is the configuration file for ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore-hook-connect'
	      ),
	      ' and is where you define overrides for the default ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'connect'
	      ),
	      ' behavior.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You can learn more about the configuration options ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/hooks/lore-hook-connect/' },
	        'here'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Default Config'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default config is shown below.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      /**\n       * Configuration file for connect\n       *\n       * This file is where you define overrides for the default connect behavior.\n       */\n\n      export default {\n\n        /**\n         * Extend or override the built-in blueprints. This is helpful if you want to\n         * change the interface for \'lore.connect\'.\n         *\n         * Lore has five built-in blueprints:\n         *\n         *  - all       : used for calls like getState(\'tweet.all\')\n         *  - byCid     : used for calls like getState(\'tweet.byCid\')\n         *  - byId      : used for calls like getState(\'tweet.byId\')\n         *  - find      : used for calls like getState(\'tweet.find\')\n         *  - singleton : used for calls like getState(\'currentUser\')\n         */\n\n        blueprints: {\n\n          /**\n           * As an example, the default syntax to fetch a model by id looks like this:\n           *\n           *   getState(\'tweet.byId\', {\n           *     id: 1\n           *   })\n           *\n           * If you wanted to modify the syntax to use a \'where\' clause (similar to the\n           * \'find\' blueprint) you could achieve that by overriding \'byId\' blueprint with\n           * the implementation below.\n           *\n           *   getState(\'tweet.find\', {\n           *     where: {\n           *       id: 1\n           *     }\n           *   })\n           */\n\n          // byId: {\n          //   defaults: {\n          //     where: {\n          //       id: null\n          //     }\n          //   },\n          //\n          //   verifyParams: function(params) {\n          //     if (!params.where.id) {\n          //       throw new Error(\'Missing required field: id\');\n          //     }\n          //   },\n          //\n          //   getPayload: function (reducerState, params) {\n          //     const key = params.where.id;\n          //     return reducerState[key];\n          //   },\n          //\n          //   callAction: function (action, params) {\n          //     const id = params.where.id;\n          //     return action(id).payload;\n          //   }\n          // }\n\n        },\n\n        /**\n         * Add custom reducer-action maps here, or override existing ones\n         *\n         * This map determines what action gets called when the requested\n         * reducer state does not exist. The blueprint is responsible for:\n         *\n         * 1. Validating the parameters passed to the getState method\n         * 2. Extracting the desired state from the Redux Store\n         * 3. Calling the action if that state does not exist\n         */\n\n        reducerActionMap: {\n\n          /**\n           * There are five blueprints built into the framework, with mappings\n           * that look like this. These are examples of the mappings automatically\n           * created by the framework based on conventions.\n           *\n           * The \'*\' in the mappings below is special syntax that means "put the\n           * name of the model here". It allows you to say "this mapping applies\n           * to all models". For example, \'*.find\' will apply to \'tweet.find\',\n           * \'user.find\', etc.\n           *\n           * You can reuse built-in blueprints by setting the value of blueprint\n           * to the name of the blueprint you want to reuse.\n           */\n\n          // \'*.all\': {\n          //   action: null,\n          //   reducer: \'*.find\',\n          //   blueprint: \'find\'\n          // },\n          //\n          // \'*.byCid\': {\n          //   action: null,\n          //   reducer: \'*.byCid\',\n          //   blueprint: \'byCid\'\n          // },\n          //\n          // \'*.byId\': {\n          //   action: \'*.get\',\n          //   reducer: \'*.byId\',\n          //   blueprint: \'byId\'\n          // },\n          //\n          // \'*.find\': {\n          //   action: \'*.find\',\n          //   reducer: \'*.find\',\n          //   blueprint: \'find\'\n          // },\n          //\n          // \'currentUser\': {\n          //   action: \'currentUser\',\n          //   reducer: \'currentUser\',\n          //   blueprint: \'singleton\'\n          // },\n\n          /**\n           * If the built-in blueprints don\'t work for you, you can use a custom\n           * blueprint by providing an object as the value of the blueprint. The\n           * code below mimics the built-in singleton blueprint.\n           */\n\n          // \'currentUser\': {\n          //   action: \'currentUser\',\n          //   reducer: \'currentUser\',\n          //   blueprint: {\n          //     getPayload: function(reducerState, params) {\n          //       return reducerState;\n          //     },\n          //\n          //     callAction: function(action, params) {\n          //       return action().payload;\n          //     }\n          //   }\n          // }\n\n        }\n\n      }\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-anatomy-config-connect-js-add7d8693bd7efdd870b.js